// via production/server/services/rewards.js
// this file should be kept in sync with production/server/services/rewards.js

// Define the rewards for each level
export const REWARD_TYPES = Object.freeze({
    Credits: 'credits',
    Gold: 'gold',
    RandomItem: 'random',
    Item: 'item'
})

export const RARITY_TYPES = Object.freeze({
    Common: 'common',
    Rare: 'rare',
    Epic: 'epic',
    Legendary: 'legendary',
    Mythical: 'mythical'
})

const { Credits, Gold, RandomItem, Item } = REWARD_TYPES
const { Common, Rare, Epic, Legendary, Mythical } = RARITY_TYPES

export const XP_LEVELS = Object.freeze(
    Object.values({
        '1': 700,
        '2': 1400,
        '3': 2100,
        '4': 2800,
        '5': 3500,
        '6': 4250,
        '7': 5050,
        '8': 5900,
        '9': 6850,
        '10': 7850,
        '11': 8950,
        '12': 10150,
        '13': 11450,
        '14': 12900,
        '15': 14450,
        '16': 16150,
        '17': 17950,
        '18': 19900,
        '19': 22000,
        '20': 24250,
        '21': 26650,
        '22': 29200,
        '23': 31900,
        '24': 34800,
        '25': 37850,
        '26': 41100,
        '27': 44550,
        '28': 48150,
        '29': 51950,
        '30': 55950,
        '31': 60150,
        '32': 64550,
        '33': 69150,
        '34': 73950,
        '35': 79000,
        '36': 84250,
        '37': 89700,
        '38': 95400,
        '39': 101300,
        '40': 107450,
        '41': 113850,
        '42': 120450,
        '43': 127300,
        '44': 134400,
        '45': 141750,
        '46': 149350,
        '47': 157200,
        '48': 165300,
        '49': 173700,
        '50': 182350
    })
)

// Totals should add up to
export const LEVEL_REWARDS = Object.freeze(
    Object.values({
        "1": {
            "type": Credits,
            "premium": false,
            "value": 100
        },
        "2": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "3": {
            "type": Gold,
            "premium": true,
            "value": 1
        },
        "4": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "5": {
            "type": Credits,
            "premium": false,
            "value": 100
        },
        "6": {
            "type": RandomItem,
            "premium": true,
            "value": Common
        },
        "7": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "8": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "9": {
            "type": Gold,
            "premium": true,
            "value": 1
        },
        "10": {
            "type": Credits,
            "premium": false,
            "value": 100
        },
        "11": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "12": {
            "type": RandomItem,
            "premium": true,
            "value": Rare
        },
        "13": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "14": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "15": {
            "type": Gold,
            "premium": false,
            "value": 1
        },
        "16": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "17": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "18": {
            "type": RandomItem,
            "premium": true,
            "value": Rare
        },
        "19": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "20": {
            "type": Credits,
            "premium": false,
            "value": 100
        },
        "21": {
            "type": Gold,
            "premium": true,
            "value": 1
        },
        "22": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "23": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "24": {
            "type": RandomItem,
            "premium": true,
            "value": Rare
        },
        "25": {
            "type": Credits,
            "premium": false,
            "value": 100
        },
        "26": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "27": {
            "type": Gold,
            "premium": true,
            "value": 1
        },
        "28": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "29": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "30": {
            "type": RandomItem,
            "premium": false,
            "value": Epic
        },
        "31": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "32": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "33": {
            "type": Gold,
            "premium": true,
            "value": 1
        },
        "34": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "35": {
            "type": Credits,
            "premium": false,
            "value": 100
        },
        "36": {
            "type": RandomItem,
            "premium": true,
            "value": Epic
        },
        "37": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "38": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "39": {
            "type": Gold,
            "premium": true,
            "value": 1
        },
        "40": {
            "type": Credits,
            "premium": false,
            "value": 100
        },
        "41": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "42": {
            "type": RandomItem,
            "premium": true,
            "value": Legendary
        },
        "43": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "44": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "45": {
            "type": Gold,
            "premium": false,
            "value": 1
        },
        "46": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "47": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "48": {
            "type": Credits,
            "premium": true,
            "value": 100
        },
        "49": {
            "type": RandomItem,
            "premium": false,
            "value": Epic
        },
        "50": {
            "type": Item,
            "premium": true,
            "value": Mythical
        }
    })
)